document.addEventListener("DOMContentLoaded", function () {

  const swiperTestimoinials = new Swiper('.swiper-testimonials', {
    slidesPerView: 'auto',
    spaceBetween: 10,
    watchOverflow: true,
    loop: false,
    navigation: {
      nextEl: `.swiper-button-next-testimonials`,
      prevEl: `.swiper-button-prev-testimonials`,
    },
    pagination: {
      el: `.swiper-pagination-testimonials`,
      clickable: true,
    },
    breakpoints: {
      750: {
        slidesPerView: 'auto',
        spaceBetween: 15,
        watchOverflow: true
      }
    },

  });




});
